<template>
  <base-wrapper :loading="loadingStockMovements || loadingReceiveAll">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <base-select
          :shadow="false"
          :options="[
            {
              key: 'null',
              value: null,
              label: 'Semua',
            },
            {
              key: 'true',
              value: true,
              label: 'Diterima',
            },
            {
              key: 'false',
              value: false,
              label: 'Belum Diterima',
            },
          ]"
          v-model="filter.is_received"
          @change="loadStockMovements"
        />
        <base-input
          :shadow="false"
          type="search"
          placeholder="Cari kode atau nama"
          debounce
          v-model="filter.search"
          @native-input="loadStockMovements"
        />
      </div>
      <datatable
        compact
        :columns="[
          {
            id: 'code',
            name: 'Nomor Pengemasan',
          },
          {
            id: 'items_count',
            name: 'Total Barang',
            theadClass: 'text-right',
          },
          {
            id: 'total_weight',
            name: 'Total Berat',
            theadClass: 'text-right',
          },
          {
            id: 'total_price',
            name: 'Total Harga',
            theadClass: 'text-right',
          },
          {
            id: 'shipment_status',
            name: 'Status Pengiriman',
            theadClass: 'text-center',
          },
          {
            id: 'status',
            name: 'Status',
            theadClass: 'text-center',
          },
        ]"
        :total="stockMovements.meta.page.total"
        :perPage="stockMovements.meta.page.perPage"
        :currentPage="stockMovements.meta.page.currentPage"
        :meta="stockMovements.meta"
        cursor
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="stockMovement in stockMovements.data"
            :key="stockMovement.id"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-green-100']"
            @click.prevent="
              onClickDetail(getStockMovementIncluded(stockMovement))
            "
          >
            <td :class="classes.td">
              <div class="mb-1 font-bold text-gray-900">
                {{ getStockMovementIncluded(stockMovement).attributes.code }} /
                {{
                  getStockMovementIncluded(stockMovement).attributes.order_code
                }}
              </div>
              <p class="text-xs text-gray-500">
                {{
                  getStockMovementIncluded(stockMovement).attributes.updatedAt
                    | formatDate
                }}
              </p>
            </td>
            <td :class="[classes.td, 'text-right']">
              <!-- {{
                getStockMovementIncluded(stockMovement).attributes
                  .product_summaries
                  ? Object.keys(
                      getStockMovementIncluded(stockMovement).attributes
                        .product_summaries
                    ).length
                  : '-'
              }} -->
            </td>
            <td :class="[classes.td, 'text-right']">
              <!-- {{ getTotalWeight(getStockMovementIncluded(stockMovement)) }} -->
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                getSingleIncluded(
                  stockMovements,
                  stockMovement.relationships.order.data.id
                ).attributes.final_price | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge
                v-if="
                  getStockMovementIncluded(stockMovement).attributes.is_received
                "
                color="green"
                >Diterima</base-badge
              >
              <base-badge v-else color="red">Belum Diterima</base-badge>
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge color="indigo">{{
                getSingleIncluded(
                  stockMovements,
                  stockMovement.relationships.order.data.id
                ).attributes.order_status
              }}</base-badge>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <view-stock-movement-modal
      :stock-movement-id="detailModal.stockMovementId"
      :visible="detailModal.visible"
      with-receive-input
      :with-receive-scan-input="false"
      :columns="[]"
      with-actions
      @close="onCloseDetail"
      @received="onReceived"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import ViewStockMovementModal from '@/components/stock-movement/view-stock-movement-modal.vue';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { sum } from '../../../../../utils/array';

export default {
  name: 'Home',
  components: {
    ViewStockMovementModal,
  },
  mixins: [requestMixin],
  data() {
    return {
      detailModal: {
        visible: false,
        stockMovementId: null,
      },
      filter: {
        search: null,
        is_received: false,
      },
      loadingStockMovements: false,
      loadingReceiveAll: false,
      stockMovements: {
        meta: {
          page: {},
        },
        data: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    getStockMovementIncluded(simpleStockMovement) {
      return this.getSingleIncluded(
        this.stockMovements,
        simpleStockMovement.relationships['stock-movement'].data.id
      );
    },
    getTotalWeight(stockMovement) {
      return sum(stockMovement.attributes.packets, (packet) => {
        return sum(packet.products, (product) => product.total_weight);
      });
    },
    async loadStockMovements(params) {
      this.loadingStockMovements = true;

      const [res, err] = await this.request('/api/v1/stock-movements', {
        params: {
          'page[limit]': 5,
          'filter[destination_office_category_id]': 2,
          'filter[destination_office_id]': this.me.office_id,
          include: 'stock-movement,order',
          'filter[is_shipped]': true,
          'filter[is_received]': this.filter.is_received,
          'filter[search]': this.filter.search,
          'filter[for_reimbursement]': false,
          'filter[for_free_reimbursement]': false,
          ...params,
        },
      });

      if (!err) {
        this.stockMovements = res;
      }

      this.loadingStockMovements = false;
    },
    onChangePage(page) {
      this.loadStockMovements(page);
    },
    onClickDetail(stockMovement) {
      this.stopScanListener();
      this.detailModal.stockMovementId = stockMovement.id;
      this.detailModal.visible = true;
    },
    onReceived() {
      this.setupScanListener();
      this.detailModal.visible = false;
      this.loadStockMovements();
    },
    onCloseDetail() {
      this.setupScanListener();
      this.detailModal.visible = false;
    },
    async onScanned(e) {
      const { text: id } = e.detail;

      this.loadingReceiveAll = true;

      const [, err] = await this.request(
        `/api/v1/stock-movements/${id}/-actions/receive-all-by-id`,
        {
          method: 'patch',
        }
      );

      if (err) {
        const errorMessage = this.getRequestErrorMessage(err);

        this.createAlert({
          status: 'error',
          data:
            errorMessage instanceof Error
              ? 'QR penerimaan tidak ditemukan'
              : errorMessage,
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Pengiriman berhasil diterima semua',
        });

        this.loadStockMovements();
      }

      this.loadingReceiveAll = false;
    },
    setupScanListener() {
      document.addEventListener('barcode-scan', this.onScanned);
    },
    stopScanListener() {
      document.removeEventListener('barcode-scan', this.onScanned);
    },
  },
  created() {
    this.loadStockMovements();
    this.setupScanListener();
  },
  destroyed() {
    this.stopScanListener();
  },
};
</script>
